import { Card, Stack, Text } from '@backyard-ui/core'

import { GridContent } from 'scripts/react-components/entry-key/pages/entry/components'

export const NoServicesFound = () => {
  return (
    <GridContent
      showRetailMedia={false}
      headerProps={{ contentType: 'services' }}>
      <Card.Root>
        <Card.Body>
          <Stack
            align="center"
            direction="column"
            spacing="4"
            style={{ padding: '40px 0' }}>
            <Text size="lg" weight="bold" color="neutral-700">
              Nenhum serviço encontrado
            </Text>
            <Text size="md" color="neutral-900" align="center">
              Não encontramos serviços disponíveis para este produto.
            </Text>
          </Stack>
        </Card.Body>
      </Card.Root>
    </GridContent>
  )
}
